export enum Metric {
  Doc = "doc",
  Repost = "repost",
  Impression = "impression",
  Reach = "reach",
  Engagement = "engagement",
  EngagementPerPost = "engagement_per_post",
  Rating = "rating",
  NetSentiment = "net_sentiment",
}

export function getAllMetrics() {
  return Object.keys(Metric)
    .map((k) => Metric[k as keyof typeof Metric])
    .map((v) => v as Metric);
}
